import {
  SpecialConditionData,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client';

export const getDefaultCustomCondition = (clauseNumber?: number): SpecialConditionData => ({
  id: window.crypto.randomUUID(),
  conditionType: SpecialConditionDataConditionType.Custom,
  overriddenClauseNumber: clauseNumber,
  customCondition: {
    clauseId: window.crypto.randomUUID(),
    textInput: '',
    subClauses: [
      {
        clauseId: window.crypto.randomUUID(),
        textInput: '',
      },
    ],
  },
});
